/**
 * 사이드바 메뉴 재클릭 시 화면 새로고침 처리.
 * 이미 현재 경로에 있는 메뉴를 다시 클릭하면 react-router <Link>는 아무 동작도 하지 않으므로,
 * 같은 경로일 때 기본 네비게이션을 막고 강제로 새로고침한다.
 *
 * @returns 새로고침을 수행했으면 true, 아니면 false(일반 네비게이션 진행).
 */
export const handleMenuReClick = (
  targetHref: string,
  currentPathname: string,
  reload: () => void,
): boolean => {
  if (targetHref === currentPathname) {
    reload();
    return true;
  }
  return false;
};
